import React from 'react';
import { Grid, Skeleton } from '@exxonmobil/react-unity';

const OverviewTileLoading = () => (
  <Grid variant="4-up" data-testid="detail-loading">
    {[...Array(4)].map((_, index) => (
      <Grid.Item key={index}>
        <Skeleton height="118px" />
      </Grid.Item>
    ))}
  </Grid>
);

export default OverviewTileLoading;
